import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { ImpressionsDataService, ImpressionsColumnsService } from '../../../services';
import { Impression, ImpressionsResult } from '../../../interfaces';

@Component({
  selector: 'app-impression-form',
  templateUrl: './impression-form.component.html',
  styleUrls: ['./impression-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ImpressionFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public impression: Impression = {};
  public impressionForm: FormGroup = new FormGroup({});
  public impressions: Impression[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private impressionsDataService: ImpressionsDataService,
    public impressionsColumnsService: ImpressionsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'ImpressionFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Impression - Edit');
        this.getImpression(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.impression !== 'undefined') {
      this.impression = this.dynamicDialogConfig.data.impression;
    }
    if (typeof this.impression.id === 'undefined' || this.impression.id === null) {
      this.impression.id = null;
    }
    this.getImpressions();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'ImpressionFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'ImpressionFormComponent');
  }

  getImpression(id: number): void {
    this.isLoading = true;
    this.impressionsDataService.getImpression(id).subscribe((response: Impression|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.impression = response;
        this.prepareFrom();
      }
    });
  }

  getImpressions(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.impressions !== 'undefined' && this.dynamicDialogConfig.data.impressions.length > 0) {
      this.impressions = this.dynamicDialogConfig.data.impressions;
      return;
    }
    this.impressionsDataService.getImpressions(this.parameters).subscribe((response: ImpressionsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.impressions = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.impressionForm = new FormGroup({
      id: new FormControl(this.impression.id, []),
      visit: new FormControl((typeof this.impression.visit === 'number') ? this.impression.visit : this.impression.visit?.id, []),
      banner: new FormControl((typeof this.impression.banner === 'number') ? this.impression.banner : this.impression.banner?.id, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/impressions']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.impressionForm.controls).forEach((field: any) => {
        const control = this.impressionForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.impressionForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.impression = this.impressionForm.value;
    this.disableSubmit = true;
    console.log('impression', this.impression);
    if (typeof this.impression.id !== 'undefined' && this.impression.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.impressionsDataService.updateImpression(this.impression).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('IMPRESSIONUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('IMPRESSIONNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.impressionsDataService.addImpression(this.impression).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('IMPRESSIONCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('IMPRESSIONNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-impression-form',
  templateUrl: './impression-form.component.html',
  styleUrls: ['./impression-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogImpressionFormComponent extends ImpressionFormComponent {
}

